<template>
  <div class="kk_style">
    <div>
      <span>{{ id }}</span>
      <span>{{ name }}</span>
    </div>
    <span class="kk_style-icons">
      <custom-icon :class-name="icons.Star" @click="setFavorite" />
      <custom-icon :class-name="icons.Edit" @click="editStyle" />
    </span>
  </div>
</template>
<script>
import { icons } from "../../../../utils/icons";
import CustomIcon from "../../../commons/CustomIcon.vue";
export default {
  components: {
    CustomIcon,
  },
  props: ["id", "name"],
  emits: ["editStyle"],
  data() {
    return {
      icons: icons,
    };
  },
  methods: {
    editStyle() {
      this.$emit("editStyle", this.id);
    },
    setFavorite() {
      console.log("setFavorite");
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../../assets/styles/variables.less";
.kk_style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  border-radius: @kk-border-radius;
  background-color: lightblue;
  cursor: pointer;
  width: 100%;
  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
  }
  span {
    font-size: 14px;
    color: @kk-color-primary-blue;
  }
  &-icons {
    display: flex;
    gap: 0.5rem;
  }
}
:deep(i) {
  font-size: 15px;
}
</style>
